import { logger } from "~/utils/logger";
/**
 * Global middleware to protect ALL booking manager routes
 */
export default defineNuxtRouteMiddleware(async (to, from) => {
  // Only apply to booking-manager routes
  if (!to.path.startsWith("/booking-manager")) {
    return;
  }

  logger.log("🔒 [Booking Manager Middleware] Checking route:", to.path);

  // Server-side: allow page to load, client will handle auth
  if (process.server) {
    logger.log("⏭️  [Booking Manager Middleware] Skipping on server");
    return;
  }

  // CLIENT-SIDE ONLY: Check authentication
  const auth = useAuthStore();

  logger.log("🔍 [Booking Manager Middleware] Auth state:", {
    sessionRestored: auth.sessionRestored,
    hasUser: !!auth.user,
    role: auth.user?.role,
  });

  // Try to restore session if not already done
  if (!auth.sessionRestored) {
    logger.log("⏳ [Booking Manager Middleware] Restoring session...");
    await auth.checkKratosSession(false);
    logger.log(
      "✅ [Booking Manager Middleware] Session restored, user:",
      auth.user?.email
    );
  }

  // Check verification
  if (auth.verificationRequired) {
    logger.log(
      "📧 [Booking Manager Middleware] Verification required, redirecting"
    );
    return navigateTo("/verification", { replace: true });
  }

  // Block if no user
  if (!auth.user) {
    logger.log("❌ [Booking Manager Middleware] No user, redirecting to login");
    return navigateTo("/login", { replace: true });
  }

  // Block if not BOOKING_MANAGER role (NOT admin, only booking manager)
  if (auth.user.role !== "BOOKING_MANAGER") {
    logger.log(
      "🚫 [Booking Manager Middleware] Invalid role:",
      auth.user.role,
      "- redirecting to home"
    );
    return navigateTo("/", { replace: true });
  }

  logger.log(
    "✅ [Booking Manager Middleware] Access granted for:",
    auth.user.email,
    "role:",
    auth.user.role
  );
});
